import {
  Avatar,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { Iconify } from "app/components/Iconify";
import { dateToNowDifference } from "app/helpers/date";

import { Notification } from "../entity";

// TODO: REFACTOR

export const NotificationItem = ({
  notification,
}: {
  notification: Notification;
}) => {
  const { avatarUrl, title } = renderContent(notification);

  return (
    <ListItemButton
      sx={{
        mt: "1px",
        px: 2.5,
        py: 1.5,
        ...(notification.isUnRead && {
          bgcolor: "action.selected",
        }),
      }}
    >
      <ListItemAvatar>
        <Avatar sx={{ bgcolor: "background.neutral" }}>{avatarUrl}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={title}
        secondary={
          <Typography
            sx={{
              alignItems: "center",
              color: "text.disabled",
              display: "flex",
              gap: 0.5,
              mt: 0.5,
            }}
            variant="caption"
          >
            <Iconify icon="solar:clock-circle-outline" width={14} />
            {dateToNowDifference(notification.postedAt)}
          </Typography>
        }
      />
    </ListItemButton>
  );
};

function renderContent(notification: Notification) {
  const title = (
    <Typography variant="subtitle2">
      {notification.title}
      <Typography
        component="span"
        sx={{ color: "text.secondary" }}
        variant="body2"
      >
        &nbsp; {notification.description}
      </Typography>
    </Typography>
  );

  if (notification.type === "order-placed") {
    return {
      avatarUrl: (
        <img
          alt={notification.title}
          src="/assets/icons/notification/ic-notification-package.svg"
        />
      ),
      title,
    };
  }
  if (notification.type === "order-shipped") {
    return {
      avatarUrl: (
        <img
          alt={notification.title}
          src="/assets/icons/notification/ic-notification-shipping.svg"
        />
      ),
      title,
    };
  }
  if (notification.type === "mail") {
    return {
      avatarUrl: (
        <img
          alt={notification.title}
          src="/assets/icons/notification/ic-notification-mail.svg"
        />
      ),
      title,
    };
  }
  if (notification.type === "chat-message") {
    return {
      avatarUrl: (
        <img
          alt={notification.title}
          src="/assets/icons/notification/ic-notification-chat.svg"
        />
      ),
      title,
    };
  }
  return {
    avatarUrl: notification.avatarUrl ? (
      <img alt={notification.title} src={notification.avatarUrl} />
    ) : null,
    title,
  };
}
